import {css} from 'aphrodite';
import React from 'react';

import {
  AutomationInputFileConfigEditorProps,
  automationFileConfigStyles,
  SectionNumber,
} from '../AutomationFileConfigUtils';
import ColumnsMapEditor from './ColumnsMapEditor';

export default function AutomationInputFileConfigEditorColumnsMapSection(
  props: AutomationInputFileConfigEditorProps
): JSX.Element {
  return (
    <div className={css(automationFileConfigStyles.subsection, automationFileConfigStyles.subsectionBorder)}>
      <SectionNumber sectionNumber={3} />
      <div className={css(automationFileConfigStyles.innerTitle)}>Configure columns for the input file</div>
      <div
        className={css(automationFileConfigStyles.description, automationFileConfigStyles.sectionDescription)}
      >
        Add columns and lookup column values for each source.
      </div>
      <ColumnsMapEditor {...props} />
    </div>
  );
}
